exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2gZn7yRhiaZ8Do{display:inline;border-radius:3px;background-color:hsla(0,0%,100%,.69);padding:3px 8px;font-size:11px;font-weight:700;text-transform:uppercase;line-height:16px;align-items:center;cursor:pointer;color:#172b4d;width:-webkit-fit-content;width:fit-content}", ""]);

// exports
exports.locals = {
	"boardTemplateBadge": "_2gZn7yRhiaZ8Do"
};